import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Label } from '../ui/label';

const LABEL_CLASS = 'flex flex-col gap-1 text-xs text-default-text';

export function ConfigLabel({ children, className, noLabel }: { children: ReactNode; className?: string; noLabel?: boolean }) {
  return noLabel ? <div className={cn(LABEL_CLASS, className)}>{children}</div> : <Label className={cn(LABEL_CLASS, className)}>{children}</Label>;
}
